import { Box, Skeleton } from '@mui/material';

export const MemberInfoSkeleton = () => {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', tablet: 'row' }}
      justifyContent="space-between"
      gap={{ xs: 2, tablet: 0 }}
    >
      <Box display="flex" gap={2} alignItems="center">
        <Skeleton
          variant="rounded"
          width={90}
          height={90}
          sx={{ borderRadius: 6 }}
        />
        <Box>
          <Skeleton variant="text" width={200} height={32} />
          <Skeleton variant="text" width={150} height={24} />
          <Skeleton variant="text" width={180} height={24} />
        </Box>
      </Box>
      <Box display="flex" justifyContent="flex-end" gap={2}>
        <Skeleton
          variant="rectangular"
          width={64}
          height={64}
          sx={{ borderRadius: 2 }}
        />
        <Skeleton
          variant="rectangular"
          width={64}
          height={64}
          sx={{ borderRadius: 2 }}
        />
      </Box>
      <Box>
        <Skeleton
          variant="rectangular"
          width={200}
          height={80}
          sx={{ borderRadius: 2 }}
        />
      </Box>
    </Box>
  );
};
